import { Component, OnInit } from '@angular/core';

import { Client } from 'src/providers/client/client';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';

import { Loading } from 'src/shared/components/loading/loading';

import { ParseDateTimePipe } from 'src/shared/pipes/parse-date.pipe';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { TidyStorage } from 'src/shared/providers/tidy-storage';

@Component({
    templateUrl: 'job-backup-times.html',
    selector: 'job-backup-times',
    standalone: false
})

export class JobBackupTimesPage implements OnInit {

  backupTimes: any;
  categoryImage: string;
  errorMessage: string;
  booking: any;
  jobDate: string;
  serviceName: string;
  startDatetimeLocal: string;
  addressName: string;
  dialogParams: any;
  isRightSideContent = true;
  loaded: boolean;


  boundSaveJobBackupTimes = this.saveJobBackupTimes.bind(this);

constructor(
    private client: Client,
    private navCtrl: CustomNavController,
    private storage: TidyStorage,
    private rightSidePanelService: RightSidePanelService
  ) {}

  async ngOnInit() {
    this.isRightSideContent = await this.storage.retrieve('dialog-right-side-open') || false;
    this.dialogParams = await this.storage.retrieve('dialog-params');
    this.rightSidePanelService.setDialogPageTitle('Job Backup Times');
    this.loadData();
  }

  @Loading('', true)
  async loadData() {
    try {
      this.rightSidePanelService.setDialogLoading(true);
      this.loaded = false;
      await this.getJobParams();
      await this.getJobBackupTimes();
      this.loaded = true;
      this.rightSidePanelService.setDialogLoading(false);
    } catch (_err) {
      // Silent error handling
    }
  }

  async getJobParams() {
    const params = await this.getParam('params');
    this.booking = params?.booking;
    this.categoryImage = await this.getParam('categoryImage');
    this.serviceName = await this.getParam('serviceName');
    this.startDatetimeLocal = await this.getParam('startDatetimeLocal');
    this.addressName = await this.getParam('addressName') || params?.addressName;
  }

  async getParam(paramName): Promise<any> {
    let param = this.dialogParams?.[paramName];
    if (param === null || param === undefined) {
      param = this.navCtrl.getParam(paramName)
    }
    if (param === null || param === undefined) {
      param = await this.storage.retrieve(paramName);
    }
    this.storage.save(paramName, param);
    return param;
  }

  async getJobBackupTimes() {
    const response = await this.getParam('jobBackupTimes') || await this.client.getJobBackupTimes(this.booking?.booking?.id);
    const backupTimes = [];
    const datesToDisplay = 7;
    for (let i = 0; i < datesToDisplay; i++) {
      backupTimes.push({
        date: '',
        checked: false,
        times: []
      })
    };
    let date = response[0].date;
    let dateCount = 0;
    response.map((item) => {
      if (item.date !== date) {
        date = item.date;
        dateCount += 1;
      }
      backupTimes[dateCount].date = date;
      backupTimes[dateCount].checked = backupTimes[dateCount].checked || item.selected;
      backupTimes[dateCount].times.push({
        viewValue: this.formatDate(item.start_time, 'h:mma'),
        value: item.start_time,
        checked: item.selected
      });
    })
    this.backupTimes = backupTimes;
  }

  async saveJobBackupTimes() {
    try {
      const times = this.prepareTimesPayload();
      await this.client.saveJobBackupTimes(this.booking?.booking?.id, times);
      this.goBack();
    } catch(err) {
      this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
    }
  }

  prepareTimesPayload() {
    const array = [];
    this.backupTimes.map((date) => {
      date.times.map((time) => {
        if (time.checked) {
          array.push({
            date: date.date,
            start_time: time.value
          });
        }
      })
    })
    return array;
  }

  async goBack() {
    if (this.dialogParams) {
      this.rightSidePanelService.goBack();
    } else {
      const addressId = await this.getParam('addressId');
      const params = await this.getParam('params');
      this.navCtrl.navigateBack(`job/${addressId}/${this.booking?.booking?.current_job?.id}`, params);
    }
  }

  addTimesToDate(date) {
    date.checked = true;
  }

  updateTimeChecked(date: any, index: number, checked: boolean) {
    if (date && date.times && date.times[index]) {
      date.times[index].checked = checked;
    }
  }

  formatDate(dateTime, format) {
    return new ParseDateTimePipe().transform(dateTime, format)
  }
}
